import { useMediaQuery } from 'react-responsive';
import { breakpoints, Button, Card } from '@openedx/paragon';

export const DiscountProductCardSkeleton = () => {
  const { small, isExtraSmall } = breakpoints as Record<
    string,
    { maxWidth: number }
  >;

  const isSmall = useMediaQuery({ maxWidth: small?.maxWidth });

  return (
    <Card orientation={isSmall ? 'vertical' : 'horizontal'} isLoading>
      <div className="position-relative">
        <Card.ImageCap
          src="/images/example-certificate-verified.png"
          srcAlt="Course image"
          className="card-image"
        />
      </div>
      <Card.Body>
        <Card.Header size="sm" />

        <Card.Section>&nbsp;</Card.Section>

        <Card.Footer
          orientation={isExtraSmall ? 'horizontal' : 'vertical'}
          textElement="span"
        >
          <Button as="a" href="#">
            &nbsp;
          </Button>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};
